// import 'slick-carousel';
// import $ from 'jquery';
// import scrollLock from 'scroll-lock'
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import { CustomEase } from "gsap/CustomEase";

// gsap.registerPlugin(ScrollTrigger,ScrollToPlugin,CustomEase);

ScrollTrigger.refresh();


$(document).ready(function() {
    const isMobile = window.matchMedia('(max-width: 700px)').matches;
      
     if($(".home-page").length) {
         
        animateHomepage(isMobile);
    }
    
});

function animateHomepage(is_mobile)
{
    if (is_mobile) {
        
        animateHomeMobile();
    } else {
        
        animateHomeDesktop();
    }
}

function animateHomeMobile()
{
    const heroAnimate = gsap.timeline({
      scrollTrigger: {
	       trigger: '.home-page .paragraph--type--home-hero-banner',
			start: 'top-=1 top',
			end: 'bottom top',
	  }
    });
    
        // First Step animation
        //{ duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.5);
    
        heroAnimate
            .to('.paragraph--type--home-hero-banner .top_title', { autoAlpha: 1, duration: 0.6, ease: "power2.inOut"}, 0)
            .fromTo('.paragraph--type--home-hero-banner .paragraph_title', { scale: 0.3, autoAlpha: 0 }, {autoAlpha: 1, scale: 1, duration: 1.5,}, 0)
            .to('.paragraph--type--home-hero-banner .paragraph_content', { autoAlpha: 1, duration: 0.7 , ease: "power2.out"}, 1)
            .to('.paragraph--type--home-hero-banner .paragraph_link', { autoAlpha: 1, duration: 0.6, ease: "power2.out"}, 1);
            
    // Where Next Slider
	const midSliderAnimate = gsap.timeline({
		scrollTrigger: {
			trigger: '.home-page .paragraph--type--slider-content-section',
			start: 'center bottom',
			end: 'bottom top',
			toggleActions: 'play none play reverse',
			// markers: true,
		}
	});
	midSliderAnimate
		.from('.paragraph--type--slider-content-section .picture_container', { duration: 0.5, stagger: 0.1, opacity: 0, ease: "power1.out", clearProps: true }, 0)
		.from('.paragraph--type--slider-content-section .slider_item', { duration: 0.5, stagger: 0.1, opacity: 0, ease: "power1.out", clearProps: true}, 0.5);
		
		
	// Where Next Slider
	const anyOccassionAnimate = gsap.timeline({
		scrollTrigger: {
			trigger: '.home-page .where-next',
			start: 'top bottom',
			end: 'bottom top',
			toggleActions: 'play none play reset',
			// markers: true,
		}
	});
	anyOccassionAnimate.set('.where-next .title-and-nav', { zIndex: 9 }, 0)
		.from('.where-next .title-and-nav', { duration: 1, opacity: 0, y: 50, ease: "power1.out" }, 0.5)
		.from('.collection-whisky-listing .collection-slide-image-container', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.8)
		.from('.collection-whisky-listing .collection-content-container', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 1);
		
		
		// Where Next Slider
	const granCruAnimate = gsap.timeline({
		scrollTrigger: {
			trigger: '.home-page .paragraph--type--hero-centralized-content',
			start: 'center-=30 bottom',
			end: 'bottom top',
			toggleActions: 'play none play reset',
			// markers: true,
		}
	});
	granCruAnimate.fromTo('.paragraph--type--hero-centralized-content .top_title', { autoAlpha: 0, scale: 0.5},{ autoAlpha: 1, scale: 1, duration: 0.6 }, 0)
		.fromTo('.paragraph--type--hero-centralized-content .emphasize_title', {autoAlpha: 0}, { duration: 0.6, autoAlpha: 1, ease: "power1.out" }, 1)
		.fromTo('.paragraph--type--hero-centralized-content .bold_content', { autoAlpha: 0, scale: 0.2 }, { duration: 0.6, autoAlpha: 1, scale: 1, ease: "power1.out" }, 1)
		.fromTo('.paragraph--type--hero-centralized-content .small', { autoAlpha: 0 }, { duration: 0.6, autoAlpha: 1, ease: "power1.out" }, 1.5)
		
		
		
	// const teaserAnimate = gsap.timeline({
	// 	scrollTrigger: {
	// 		trigger: '.home-page .paragraph--type--content-with-teaser',
	// 		start: 'top+=50 bottom',
	// 		end: 'bottom bottom',
	// 		toggleActions: 'play none play reset',
	// 		// markers: true,
	// 	}
	// });
// 	teaserAnimate
// 	    .set(".paragraph--type--content-with-teaser .teaser_item_image img", { autoAlpha: 0 })
// 	    .set(".paragraph--type--content-with-teaser .videobg-widget .desktop-video", { y: "-100vh" })
// 	    //.set(".paragraph--type--content-with-teaser .videobg-widget .mobile-video", { y: "-100vh" })
// 	    // .set(".paragraph--type--content-with-teaser .center_image img", { y: 800, x: '-50%' })
// 	    .from('.paragraph--type--content-with-teaser .videobg-widget .desktop-video', { y: "-100vh", duration: 1.5 }, 0.2)
// 	    //.from('.paragraph--type--content-with-teaser .videobg-widget .mobile-video', { y: "-100vh", duration: 1.5 }, 0.2)
// // 		.from('.teaser_item_image', { y: "0", duration: 1.5 }, 0.2)
// 		.from('.paragraph--type--content-with-teaser .center_image img', { y: 800, ease: "power4.out", duration: 1.5 }, 0.5)
// 		.from('.paragraph--type--content-with-teaser .paragraph--type--teaser-item .teaser_item_content .title', { y: "70vh", stagger: 0.05, ease: "power4.out", duration: 1 }, 0.5)
// 		.from('.paragraph--type--content-with-teaser .paragraph--type--teaser-item .teaser_item_table', { autoAlpha: 0, ease: "power4.out" , duration: 1 }, 1.5)
// 		.from('.paragraph--type--content-with-teaser .paragraph--type--teaser-item .link', { autoAlpha: 0, ease: "power4.out" , duration: 1 }, 1.5)
		
}

function animateHomeDesktop()
{
    
    const heroAnimate = gsap.timeline({
      scrollTrigger: {
	       trigger: '.home-page .paragraph--type--home-hero-banner',
			start: 'top-=1 top',
			end: 'bottom top',
// 			pin: true,
// 			pinSpacing: true,
			// markers: true,
// 			scrub: true,
	  }
    });
    
        // First Step animation
        //{ duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.5);
    
        heroAnimate
            .to('.paragraph--type--home-hero-banner .top_title', { autoAlpha: 1, duration: 0.6, ease: "power2.inOut"}, 0)
            .fromTo('.paragraph--type--home-hero-banner .paragraph_title', { scale: 0.3, autoAlpha: 0 }, {autoAlpha: 1, scale: 1, duration: 1.5,}, 0)
            .to('.paragraph--type--home-hero-banner .paragraph_content', { autoAlpha: 1, duration: 0.7 , ease: "power2.out"}, 1)
            .to('.paragraph--type--home-hero-banner .paragraph_link', { autoAlpha: 1, duration: 0.6, ease: "power2.out"}, 1);
            
    // Where Next Slider
	const midSliderAnimate = gsap.timeline({
		scrollTrigger: {
			trigger: '.home-page .paragraph--type--slider-content-section',
			start: 'center bottom',
			end: 'bottom top',
			toggleActions: 'play none play reverse',
			// markers: true,
		}
	});
	midSliderAnimate
		.from('.paragraph--type--slider-content-section .picture_container', { duration: 0.5, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0)
		.from('.paragraph--type--slider-content-section .slider_item', { duration: 0.5, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.5);
		
		
	// Where Next Slider
	const anyOccassionAnimate = gsap.timeline({
		scrollTrigger: {
			trigger: '.home-page .where-next',
			start: 'top bottom',
			end: 'bottom top',
			toggleActions: 'play none play reset',
			// markers: true,
		}
	});
	anyOccassionAnimate.set('.where-next .title-and-nav', { zIndex: 9 }, 0)
		.from('.where-next .title-and-nav', { duration: 1, opacity: 0, y: 50, ease: "power1.out" }, 0.5)
		.from('.collection-whisky-listing .collection-slide-image-container', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 0.8)
		.from('.collection-whisky-listing .collection-content-container', { duration: 1, stagger: 0.1, opacity: 0, y: 200, ease: "power1.out" }, 1);
		
		
		// Where Next Slider
	const granCruAnimate = gsap.timeline({
		scrollTrigger: {
			trigger: '.home-page .paragraph--type--hero-centralized-content',
			start: 'center-=30 bottom',
			end: 'bottom top',
			toggleActions: 'play none play reset',
			// markers: true,
		}
	});
	granCruAnimate.fromTo('.paragraph--type--hero-centralized-content .top_title', { autoAlpha: 0, scale: 0.5},{ autoAlpha: 1, scale: 1, duration: 0.6 }, 0)
		.fromTo('.paragraph--type--hero-centralized-content .emphasize_title', {autoAlpha: 0}, { duration: 0.6, autoAlpha: 1, ease: "power1.out" }, 1)
		.fromTo('.paragraph--type--hero-centralized-content .bold_content', { autoAlpha: 0, scale: 0.2 }, { duration: 0.6, autoAlpha: 1, scale: 1, ease: "power1.out" }, 1)
		.fromTo('.paragraph--type--hero-centralized-content .small', { autoAlpha: 0 }, { duration: 0.6, autoAlpha: 1, ease: "power1.out" }, 1.5)
		
		
		
	// const teaserAnimate = gsap.timeline({
	// 	scrollTrigger: {
	// 		trigger: '.home-page .paragraph--type--content-with-teaser',
	// 		start: 'top+=50 bottom',
	// 		end: 'bottom bottom',
	// 		toggleActions: 'play none play reset',
	// 		// markers: true,
	// 	}
	// });
	
	// teaserAnimate
	//     .set(".paragraph--type--content-with-teaser .teaser_item_image img", { autoAlpha: 0 })
	//     .set(".paragraph--type--content-with-teaser .videobg-widget .desktop-video", { y: "-100vh" })
	//     //.set(".paragraph--type--content-with-teaser .videobg-widget .mobile-video", { y: "-100vh" })
	//     // .set(".paragraph--type--content-with-teaser .center_image img", { y: 800, x: '-50%' });
	
// 	 teaserAnimate
// 	    .from('.paragraph--type--content-with-teaser .videobg-widget .desktop-video', { y: "-100vh", duration: 1.5 }, 0.2)
// 	    //.from('.paragraph--type--content-with-teaser .videobg-widget .mobile-video', { y: "-100vh", duration: 1.5 }, 0.2)
// // 		.from('.teaser_item_image', { y: "0", duration: 1.5 }, 0.2)
// 		.fromTo('.paragraph--type--content-with-teaser .center_image img', { y: 800 },  { y: 0, ease: "power4.out", duration: 1.5 }, 0.5)
// 		.from('.paragraph--type--content-with-teaser .paragraph--type--teaser-item .teaser_item_content .title', { y: "70vh", stagger: 0.05, ease: "power4.out", duration: 1 }, 0.5)
// 		.from('.paragraph--type--content-with-teaser .paragraph--type--teaser-item .teaser_item_table', { autoAlpha: 0, ease: "power4.out" , duration: 1 }, 1.5)
// 		.from('.paragraph--type--content-with-teaser .paragraph--type--teaser-item .link', { autoAlpha: 0, ease: "power4.out" , duration: 1 }, 1.5)
}